module.exports = __webpack_public_path__ + "img/shield.ccab9619.svg";